import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Survey, SurveyService } from '../services/survey.service';
import { SurveyConsentComponent } from '../survey-consent/survey-consent.component';
import { SurveyWriterComponent } from '../survey-writer/survey-writer.component';
import { SurveyFileComponent } from '../survey-file/survey-file.component';
import { SurveyEmailComponent } from '../survey-email/survey-email.component';

@Component({
    selector: 'ell-survey',
    standalone: true,
    imports: [SurveyEmailComponent, SurveyConsentComponent, SurveyWriterComponent, SurveyFileComponent],
    templateUrl: './survey.component.html',
    styleUrl: './survey.component.scss'
})
export class SurveyComponent implements OnChanges {
    @Input()
    survey?: Survey;

    constructor(private surveyService: SurveyService) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if ((<Survey>changes['survey'].previousValue)?.id !== (<Survey>changes['survey'].currentValue)?.id) {
            // Firefox doesn't want to always scroll if it hasn't rendered yet or something,
            // so let's try it a few times
            for (const attempt of [0, 5, 100, 200, 500]) {
                setTimeout(() => {
                    window.scrollTo(0, 0);
                }, attempt);
            }
        }
    }

    complete(answers: Survey['answers']) {
        this.surveyService.complete(this.survey!.id, answers);
    }
}
